import { lighten, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 19fr'
  },
  tapRow: {
    display: 'flex',
    alignItems: 'center'
  },
  tapContent: {
    flex: 1,
    minWidth: 0
  },
  tapConnector: {
    width: 22,
    flex: 'none',
    marginRight: 4,
    borderTop: `2px dashed ${lighten(theme.palette.primary.main, 0.45)}`,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      right: -6,
      top: -5,
      border: '5px solid transparent',
      borderLeftColor: lighten(theme.palette.primary.main, 0.45)
    }
  },
  priceActionContainer: {
    display: 'grid',
    gridTemplateColumns: '4fr 4fr 4fr 1fr',
    background: theme.palette.grey[200],
    marginTop: 10,
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '2fr 0.5fr'
    }
  },
  priceActionContainerWithError: {
    border: `1px solid ${theme.palette.error.main}`
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 4,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 16
    }
  },
  titleContainerMargin: {
    paddingBottom: 8,
    paddingLeft: 16
  },
  title: {
    color: theme.palette.grey[600]
  },
  subTitle: {
    color: theme.palette.grey[800]
  },
  buttonsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr'
  },
  editIconContainer: {
    color: theme.palette.primary.main
  },
  deleteIconContainer: {
    color: theme.palette.grey[700]
  },
  arrowIconContainer: {
    background: theme.palette.primary.main,
    borderRadius: 0,
    marginTop: 10,
    marginRight: 10,
    cursor: 'grab',
    '&:hover': {
      background: theme.palette.primary.main
    }
  },
  arrowDownward: {
    transform: 'rotate(-90deg)',
    color: theme.palette.primary.contrastText
  },
  arrowUpward: {
    transform: 'rotate(90deg)',
    color: theme.palette.primary.contrastText
  },
  swapVertIcon: {
    color: theme.palette.primary.contrastText
  },
  // DISPLAY sink — drag handle in a lighter shade of the brand red (structural, only shown in
  // reorder mode). The body stays the normal grey; the sink is signalled by the badge below.
  arrowIconContainerSink: {
    background: lighten(theme.palette.primary.main, 0.55),
    '&:hover': {
      background: lighten(theme.palette.primary.main, 0.55)
    }
  },
  // Neutral (non-red) type chip (Capture / Transform) — red is reserved for alerts/warnings.
  typeBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 0.4,
    color: theme.palette.grey[700],
    background: theme.palette.grey[300],
    borderRadius: 4,
    padding: '2px 7px',
    marginLeft: 8,
    verticalAlign: 'middle'
  },
  typeInfoIcon: {
    fontSize: 14,
    color: theme.palette.grey[600],
    cursor: 'help'
  }
}))

export default useStyles
